module.exports = __webpack_public_path__ + "img/wanwu_10.33170e99.png";